export default "__VITE_ASSET__BW6ro9D4__"